import Link from 'next/link';
import { FC } from 'react';
import { H2 } from 'atoms/Typography';
import { Modal } from 'molecules/Modal';
import { useTranslations } from 'modules/i18n/useTranslations';
import bg from './geo.jpeg';
import { IGeoView } from './types';
import styles from './styles.module.css';

export const GeoPopupView: FC<IGeoView> = ({
  open,
  onClose,
  url,
  countryCode,
}) => {
  const t = useTranslations();
  const handleClose = () => {
    onClose?.();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      classes={{ paper: styles.modal }}
      customClasses={{
        header: styles.header,
        closeIcon: styles.closeIcon,
      }}
    >
      <img className={styles.bg} src={bg.src} alt="Geo popup image" />
      <div className={styles.content}>
        <H2 className={styles.text}>
          {t.rich('geo.text', {
            br: () => <br />,
          })}
        </H2>
        {countryCode && (
          <Link href={url} onClick={handleClose} className={styles.button}>
            {t('geo.button', { locale: countryCode?.toUpperCase() })}
          </Link>
        )}
      </div>
    </Modal>
  );
};
